import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import {
  AnonymousFormModel,
  AuthenticatedFormModel,
  PermissionModel,
} from '../permissions';
import { RefProperty } from '../ref-property.model';
import { SideBarConfigModel } from '../sidebar-config.model';
import { ApplicationSharingPresenter } from './application-sharing-presnter-model';
import {
  GenericViewGroupModel,
  GenericViewWidgetPresenterModel,
} from './generic-view-widget-presenter-model';

export class GenericViewPresenterModel {
  anonymous?: AnonymousFormModel;
  authenticated?: AuthenticatedFormModel;
  description?: LocalizedValueModel;
  icon?: IconModel;
  id?: string;
  isPinned?: boolean;
  isPublished?: boolean;
  name: LocalizedValueModel;
  domain?: RefProperty;
  sharing: ApplicationSharingPresenter;
  relatedTo?: RefProperty;
  specificationVersion: number;
  permissions?: Array<PermissionModel>;
  components?: Array<GenericViewWidgetPresenterModel>;
  groups?: Array<GenericViewGroupModel>;
  sidebarConfig?: SideBarConfigModel;
  displayConfig?: PageDisplayOptions;
  displayOrder?: number;
  uiAttributes?: { cssStyles?: string };
  allowExportPDF?: boolean;
  autoRefresh?: boolean;
  autoRefreshInterval?: number;
  pageType?: PageType;
  embeddedPageConfig?: { url?: string };
  redirectionRules?: string;
  defaultPageForSpaces?: RefProperty[];
  updateIdentifier?: string;
  help?: {
    contextualHelp?: LocalizedValueModel;
  };
}

export interface PageDisplayOptions {
  transparent?: boolean;
  fullPage?: boolean;
  outerSpacing?: boolean;
  showPageHeader?: boolean;
  pageContainedWidth?: boolean;
}

export enum PageContainerLayoutMode {
  Fluid = 0,
  Contained = 1,
}
export enum PageType {
  Normal = 0,
  Embedded = 1,
}
export enum GenericViewRedirectionRuleRedirectConfigTypeEnum {
  FixedUrl = 0,
  DataView = 1,
  GenericView = 2,
  Report = 3,
}
export enum GenericViewRedirectionRuleAccessEnum {
  Anonymous = 0,
  Authenticated = 1,
  Everyone = 2,
  Restricted = 3,
}
